import { descend, prop, sort } from "ramda";
import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import { IApprovalItem, IApprovalItemRow } from "../../../models/Approval";
import { RequestOperationType } from "../../../models/Operation";
import { RequestStatusType } from "../../../models/Status";
import { ITaskItem } from "../../../models/Task";
import { immutableSet } from "../../../utils/immutable";
import { actionTypes } from "./actions";
import {
  APPROVAL_DETAIL_IDENTIFIER,
  APPROVALS_IDENTIFIER,
  APPROVALS_LOADER_IDENTIFIER,
  APPROVAL_MAIN_CALL_STATE,
  SELECTED_APPROVAL_IDENTIFIER,
  TAB_SELECTED_IDENTIFIER,
  ATTACHMENT_CALL_STATE_IDENTIFIER,
  ATTACHMENT_CALL_STATE_IDENTIFIER_SAVE,
  ORIGINAL_APPROVAL_LIST_IDENTIFIER,
  APPROVALS_CSV_DISABLED,
  APPROVALS_CSV_DATA,
} from "./constants";
import emptyState from "./emptyState";
import moment from "moment";
import { compose } from "redux";
import { IDENTITY_SYSTEM } from "../../../module/constants";

const ACTION_HANDLERS = {
  [actionTypes.SELECT_APPROVAL]: (
    state: any,
    action: { type: string; payload: IApprovalItem }
  ) => {
    return immutableSet([SELECTED_APPROVAL_IDENTIFIER], action.payload, state);
  },

  [actionTypes.FETCH_PAGINATION_APPROVALS_REQUEST]: (state: any) => {
    return compose(
      immutableSet([APPROVALS_LOADER_IDENTIFIER], true),
      immutableSet([APPROVALS_IDENTIFIER], null),
      immutableSet([ORIGINAL_APPROVAL_LIST_IDENTIFIER], [])
    )(state);
  },

  [actionTypes.FETCH_PAGINATION_APPROVALS_SUCCESS]: (
    state: any,
    action: any
  ) => {
    const { approvals, ...paginationData } = action.payload;
    const fineApprovals: IApprovalItem[] = [];

    if (approvals) {
      approvals.length > 0 &&
        approvals.forEach((data: any) => {
          const tempRow: IApprovalItem = {
            id: data.id,
            internal_id: data.internal_id,
            hide_status: RequestStatusType[data.status],
            type: RequestOperationType[data.type],
            application: data.application ? data.application : "",
            entitlement: data.entitlement ? data.entitlement : "",
            approvalBao: data.owner ? data.owner : "",
            created_on: data.created_on
              ? moment(data.created_on).format("DD/MM/YYYY - HH:mm")
              : "",
            beneficiary: data.beneficiary
              ? data.beneficiary_code
                ? `${data.beneficiary} [${data.beneficiary_code}]`
                : data.beneficiary
              : "",
            applicant: data.applicant
              ? data.applicant_id
                ? `${data.applicant} [${data.applicant_id}]`
                : data.applicant
              : "",
            parent_id: data.parent_id,
            identitySystemId:
              IDENTITY_SYSTEM[
                data.identity_system_id as keyof typeof IDENTITY_SYSTEM
              ],
          };
          fineApprovals.push(tempRow);
        });
    }

    const mappedResponse = { ...paginationData, approvals: fineApprovals };
    return compose(
      immutableSet([APPROVALS_LOADER_IDENTIFIER], false),
      immutableSet([APPROVALS_IDENTIFIER], mappedResponse),
      immutableSet(
        [ORIGINAL_APPROVAL_LIST_IDENTIFIER],
        action.payload.approvals
      )
    )(state);
  },

  [actionTypes.FETCH_PAGINATION_APPROVALS_FAILURE]: (state: any) => {
    return compose(
      immutableSet([APPROVALS_LOADER_IDENTIFIER], false),
      immutableSet([APPROVALS_IDENTIFIER], null),
      immutableSet([ORIGINAL_APPROVAL_LIST_IDENTIFIER], [])
    )(state);
  },

  [actionTypes.FETCH_CSV_APPROVALS_REQUEST]: (state: any) => {
    return compose(
      immutableSet([APPROVALS_CSV_DISABLED], true),
      immutableSet([APPROVALS_CSV_DATA], [])
    )(state);
  },

  [actionTypes.FETCH_CSV_APPROVALS_SUCCESS]: (state: any, action: any) => {
    const { approvals, ...paginationData } = action.payload;
    const fineApprovals: IApprovalItem[] = [];

    approvals.length > 0 &&
      approvals.forEach((data: any) => {
        const tempRow: IApprovalItem = {
          id: data.id,
          internal_id: data.internal_id,
          hide_status: RequestStatusType[data.status],
          type: RequestOperationType[data.type],
          application: data.application ? data.application : "",
          entitlement: data.entitlement ? data.entitlement : "",
          approvalBao: data.owner ? data.owner : "",
          created_on: data.created_on
            ? moment(data.created_on).format("DD/MM/YYYY - HH:mm")
            : "",
          beneficiary: data.beneficiary
            ? data.beneficiary_code
              ? `${data.beneficiary} [${data.beneficiary_code}]`
              : data.beneficiary
            : "",
          applicant: data.applicant
            ? data.applicant_id
              ? `${data.applicant} [${data.applicant_id}]`
              : data.applicant
            : "",
          parent_id: data.parent_id,
          identitySystemId:
            IDENTITY_SYSTEM[
              data.identity_system_id as keyof typeof IDENTITY_SYSTEM
            ],
        };
        fineApprovals.push(tempRow);
      });

    return compose(
      immutableSet([APPROVALS_CSV_DATA], fineApprovals),
      immutableSet([APPROVALS_CSV_DISABLED], false)
    )(state);
  },

  [actionTypes.FETCH_CSV_APPROVALS_FAILURE]: (state: any) => {
    return compose(
      immutableSet([APPROVALS_CSV_DATA], []),
      immutableSet([APPROVALS_CSV_DISABLED], false)
    )(state);
  },

  [actionTypes.APPROVE_APPROVAL_REQUEST]: (state: any) => {
    return immutableSet(
      [APPROVAL_MAIN_CALL_STATE],
      IResponseState.PENDING,
      state
    );
  },

  [actionTypes.APPROVE_APPROVAL_REQUEST_SUCCESS]: (state: any) => {
    return immutableSet(
      [APPROVAL_MAIN_CALL_STATE],
      IResponseState.SUCCESS,
      state
    );
  },
  [actionTypes.APPROVE_APPROVAL_REQUEST_FAIILURE]: (state: any) => {
    return immutableSet(
      [APPROVAL_MAIN_CALL_STATE],
      IResponseState.ERROR,
      state
    );
  },

  [actionTypes.REJECT_APPROVALS_REQUEST]: (state: any) => {
    return immutableSet(
      [APPROVAL_MAIN_CALL_STATE],
      IResponseState.PENDING,
      state
    );
  },
  [actionTypes.REJECT_APPROVALS_REQUEST_SUCCESS]: (state: any) => {
    return immutableSet(
      [APPROVAL_MAIN_CALL_STATE],
      IResponseState.SUCCESS,
      state
    );
  },

  [actionTypes.REJECT_APPROVALS_REQUEST_FAILURE]: (state: any) => {
    return immutableSet(
      [APPROVAL_MAIN_CALL_STATE],
      IResponseState.ERROR,
      state
    );
  },

  [actionTypes.FETCH_APPROVAL_DETAIL_SUCCESS]: (
    state: any,
    action: { type: string; payload: any }
  ) => {
    return immutableSet([APPROVAL_DETAIL_IDENTIFIER], action.payload, state);
  },
  [actionTypes.RESET_APPROVAL_DETAIL]: (
    state: any,
    action: { type: string }
  ) => {
    return immutableSet([APPROVAL_DETAIL_IDENTIFIER], null, state);
  },

  [actionTypes.SELECT_TAB]: (
    state: any,
    action: { type: string; payload: any }
  ) => {
    return immutableSet([TAB_SELECTED_IDENTIFIER], action.payload, state);
  },

  [actionTypes.DELETE_ATTACHMENT_APPROVALS]: (state: any, action: any) =>
    immutableSet(
      [ATTACHMENT_CALL_STATE_IDENTIFIER],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.DELETE_ATTACHMENT_APPROVALS_SUCCESS]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [ATTACHMENT_CALL_STATE_IDENTIFIER],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.DELETE_ATTACHMENT_APPROVALS_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [ATTACHMENT_CALL_STATE_IDENTIFIER],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.SAVE_ATTACHMENTS_APPROVALS]: (state: any, action: any) =>
    immutableSet(
      [ATTACHMENT_CALL_STATE_IDENTIFIER_SAVE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.SAVE_ATTACHMENTS_APPROVALS_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [ATTACHMENT_CALL_STATE_IDENTIFIER_SAVE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.SAVE_ATTACHMENTS_APPROVALS_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [ATTACHMENT_CALL_STATE_IDENTIFIER_SAVE],
      IResponseState.ERROR,
      state
    ),
};

export default function communicationReducer(state = emptyState, action: any) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    action.payload.location.pathname === "/welcome"
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
